import React from "react"
import { Route, Routes } from "react-router-dom"
import { Login } from "../views/auth/Login.view"
import { RecuperarContrasena } from "../views/auth/RecuperarContrasena.view"
import { LoginRedirect } from "../views/systemPages/LoginRedirect.view"
import { Logout } from "../views/auth/Logout.view"
import { AppRoutes } from "../consts/appRoutes.consts"
import { Survey } from "../views/surveys/Survey.view"
export function UnauthorizedRoutes() {
  return (
    <>
      <Routes>
        <Route path={"/"} element={<Login />} />
        <Route
          path={"/recuperar-contrasena"}
          element={<RecuperarContrasena />}
        />
        <Route path={AppRoutes.surveys.survey} element={<Survey />} />
        <Route path={"/logout"} element={<Logout />} />
        <Route path={"*"} element={<LoginRedirect />} />
      </Routes>
    </>
  )
}
